/* eslint-disable */ import { memoEval, replaceEntityRecipesComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const kickPlateCountersinkHolesComponents = [
    attachComponent.withComponent(replaceEntityRecipesComponent, 'default', true).withEntity('KickPlateCountersinkHoles').attach(memoEval((self)=>[
            self.$kickPlateBoltHolesRecipes
        ], ($kickPlateBoltHolesRecipes)=>({
            recipes: $kickPlateBoltHolesRecipes,
            keepChildren: true
        })))
];

//# sourceMappingURL=kick-plate-countersink-holes.js.map